import {Vue} from 'ui.vue';

export default {
	name: 'CatalogSort',
	template: `
		<div class="b-catalog__sorting">
		<vue-select
			:options="items"
			:value="current.label"
			:clearable="false"
			:searchable="false"
			:placeholder="loc.CITRUS_TEMPLATE_SORT_TITLE"
			:components="{OpenIndicator}"
			class="b-select qc-select"
			@input="onSelect">
		</vue-select>
		</div>
	`,
	props: {
		cookieName: {
			type: String,
			default: ""
		},
		items: {
			type: Array,
			default: []
		},
		_value: {
			type: [String, null],
			default: ""
		},
	},
	data: function () {
		return {
			value: this._value,
			valueWithOrder: null,
			OpenIndicator: {
				render: createElement => createElement('span', {
					class: {'select_toggle b-filter__icon': true},
					domProps: {
						innerHTML: '<i class="icon icon--arrow-down"></i>'
					},
				})
			},
		};
	},
	created() {
		this.valueWithOrder = this.current.value + "|" + this.current.order;
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CITRUS_TEMPLATE_SORT_");
		},
		current() {
			return this.getItem(this.value);
		}
	},
	methods: {
		getItem(value) {
			for (let i in this.items) {
				if (this.items[i].value == value) {
					return this.items[i];
				}
			}

			return null;
		},
		onSelect(event) {
			//let newValue = event.value.split("|")[0];
			//let newItem = this.getItem(newValue);
			this.onToggle(event);
		},
		onSort() {
			if (this.current) {
				if (this.cookieName) {
					BX.setCookie(
						this.cookieName,
						this.current.code + ":" + this.current.order,
						{path: "/"}
					);
				}

				//BX.onCustomEvent('CatalogSectionDefault:sort', [this.current.code, this.current.order]);
				this.$emit('sort', {
					code: this.current.code,
					order: this.current.order
				})
			}
		},
		onToggle(item) {
			if (this.value == item.value) {
				if (item.hasOwnProperty('change_disable') && item.change_disable) {
					return;
				} else {
					item.order = item.order == "asc" ? "desc" : "asc";
				}
			}

			this.value = item.value;
			this.valueWithOrder = item.value + "|" + item.order;

			this.onSort();
		}
	},
};
